import { type FC } from 'react'

import { Shimmer } from '@wartek-id/shimmer'

import FilterButtons from 'app/KinerjaShared/components/FilterButtons'
import { RoleLabel } from 'app/KinerjaKSPage/utils/profile'

import type { KinerjaRoleType } from 'types/kinerja'

export interface FileItem {
  label: string
  value: KinerjaRoleType
}

type FilterItems = Array<FileItem>

interface FilterUserRoleProps {
  isLoading?: boolean
  activeFilter?: KinerjaRoleType
  onChange?: (value: KinerjaRoleType) => void
}

const FilterUserRole: FC<FilterUserRoleProps> = ({
  isLoading,
  activeFilter,
  onChange,
}) => {
  const filterItems: FilterItems = ['KS_DEFINITIF', 'KS_PLT', 'GURU'].map(
    (value) => ({
      label: RoleLabel[value],
      value,
    })
  ) as { label: string; value: KinerjaRoleType }[]

  return (
    <div className="">
      {isLoading && (
        <div className="flex gap-4">
          {Array.from({ length: 5 })?.map((_, index) => (
            <Shimmer
              width={90 + index * 20}
              height={28}
              className="!rounded-full"
              key={index}
            />
          ))}
        </div>
      )}

      {!isLoading && (
        <FilterButtons
          items={filterItems}
          activeValue={activeFilter}
          btnSize="sm"
          onChange={(value) => onChange?.(value)}
        />
      )}
    </div>
  )
}
export default FilterUserRole
